<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h4>Препараты в наличии на складе</h4>
      </div>
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading">
          <!--          <div>-->
          <!--            <label><input type="checkbox" v-model="showFilledRecords"> показать заполненые препараты</label>-->
          <!--          </div>-->
          <!--          <div class="form-group">-->
          <!--            <label for="">Поиск препарата</label>-->
          <!--            <input placeholder="Введите название для поиска" type="text" @change="filterDrugs" keyup="onInputSearch"-->
          <!--                   class="form-control"-->
          <!--                   v-model="searchDrugText">-->
          <!--          </div>-->
          <template v-if="Object.keys(drugDetails).length">
            <table class="table table-sm table-hover mt-2">
              <thead>
              <tr>
                <th>#</th>
                <th></th>
                <th>препарат</th>
                <th>страна</th>
                <th>название в стране</th>
                <th>ширина (мм)</th>
                <th>высота (мм)</th>
                <th>глубина (мм)</th>
                <th>вес (гр)</th>
              </tr>
              </thead>
              <tbody>
              <!--              <template v-for="(r,i) in showFilledRecords ? [...filteredRecords, ...filledRecords] : filteredRecords">-->
              <template v-for="(r,id,i) in drugDetails">
                <tr :key="r.drug.id">
                  <td :rowspan="r.details.country_data.dimensions.length + 1">{{ i + 1 }}</td>

                  <td :rowspan="r.details.country_data.dimensions.length + 1">
                    <v-popover
                      class="d-inline"
                      placement="bottom"
                      :auto-hide="true"
                    >
                      <i class="icon-fa icon-fa-photo pointer"></i>
                      <template slot="popover">
                        <img v-if="drugsImages[r.drug.id]" :src="drugsImages[r.drug.id]" alt="">
                      </template>
                    </v-popover>
                  </td>
                  <td :rowspan="r.details.country_data.dimensions.length + 1">
                    <i>{{ r.drug.title }}</i>
                    <p><strong>{{ r.drug.en_title }}</strong></p>
                    <p>{{ r.drug.id }}</p>
                    <p v-if="r.drug.pack_box_comment" class="text-muted"><span class="badge badge-info"><i
                      class="icon-fa icon-fa-info"></i></span> {{ r.drug.pack_box_comment }}
                    </p>
                    <div class="alert alert-info p-1" v-if="+r.drug.pack_set > 1">
                      Делать замеры комплекта <strong>x {{ +r.drug.pack_set }}</strong>
                    </div>
                  </td>
                </tr>
                <tr v-for="d in r.details.country_data.dimensions">
                  <td>
                    <select @change="updateRecord(r.drug.id)" :disabled="d.saved" v-model="d.int_value"
                            class="form-control">
                      <option value="0" disabled>Выберите страну</option>
                      <option v-for="c in $AllCountries" :value="c.id">{{ c.name }}</option>
                    </select>
                  </td>
                  <td><p v-for="t in getTitleByCountry(+d.int_value, r.details.country_data?.title ?? [])">{{ t }}</p>
                  </td>
                  <td><input @change="updateRecord(r.drug.id)" v-model="d.array_value.width"
                             type="text"
                             placeholder="ширина"
                             class="form-control max_w"></td>
                  <td><input @change="updateRecord(r.drug.id)" v-model="d.array_value.height"
                             type="text"
                             placeholder="высота"
                             class="form-control max_w"></td>
                  <td><input @change="updateRecord(r.drug.id)" v-model="d.array_value.depth"
                             type="text"
                             placeholder="глубина"
                             class="form-control max_w"></td>
                  <td><input @change="updateRecord(r.drug.id)" v-model="d.array_value.weight"
                             type="text"
                             placeholder="вес"
                             class="form-control max_w"></td>
                </tr>
              </template>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  title: 'Габариты препаратов',
  data() {
    return {
      loading: false,
      showFilledRecords: false,
      drugsImages: {},
      searchDrugText: '',
      records: [],
      filteredRecords: [],
      filledRecords: [],
      drugDetails: {},
      countryId: 4,
      groups: {
        physics_data: {
          alias: 'dimensions',
          type: 'array',
          array_value: {depth: null, width: null, height: null, weight: null}
        }
      }
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  created() {
    this.getRecords();
  },
  methods: {
    getTitleByCountry(countryId, details) {
      return details.filter((d) => d.int_value === countryId).map((d) => d.text_value);
    },
    async updateRecord(id) {
      // console.log(record.drug.id, this.drugDetails[record.drug_id]);
      // Object.keys(this.drugDetails[record.drug_id]).forEach((countryId) => {
      //   this.drugDetails[record.drug_id][countryId].country_data.dimensions.int_value = this.drugDetails[record.drug_id][countryId].country_data.title.int_value;
      // })
      const {data} = await api.post('/new/drugs/details', {
        type: 'array',
        drug_id: id,
        details: this.drugDetails[id].details.country_data.dimensions
      });
      if (data.success) {
        toastr['success']('Сохранено!', 'Успешно');
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера!', 'Ошибка');
      }
    },
    onInputSearch(e) {
      const search = (e?.target?.value ?? '').toLowerCase();
      if (search) {
        this.searchRecords(search, this)
      } else {
        this.filterDrugs();
      }
    },
    searchRecords: _.debounce(async (search, vm) => {
      vm.filterDrugs()
    }, 750),
    filterDrugs() {
      let filtered = [];
      let filled = [];
      if (this.searchDrugText) {
        const searchText = this.searchDrugText.toLowerCase();
        console.log(searchText);
        this.filteredRecords = this.records.filter((d) => (d.drug.en_title ?? '').toLowerCase().includes(searchText) || (d.drug.title ?? '').toLowerCase().includes(searchText))
        filled = filtered.filter((r) => Object.values(this.drugDetails[r.drug.id]).find((v) => Object.keys(v.country_data.dimensions.array_value).length === 4 && !Object.values(v.country_data.dimensions.array_value).find((d) => !+d)));
      } else {
        filtered = _.orderBy(this.records, 'drug.title');
        // this.records.forEach((r) => {
        //   console.log(r.drug.id);
        //   console.log(1, Object.values(this.drugDetails[r.drug.id]));
        //   console.log(2, Object.values(this.drugDetails[r.drug.id]).find((v) => Object.keys(v.country_data.dimensions.array_value).length === 4));
        //   console.log(3, Object.values(this.drugDetails[r.drug.id]).find((v) => Object.values(v.country_data.dimensions.array_value).filter((d) => !d).length === 0));
        // })

        // const fillCheckKeys = ['width', 'height', 'depth', 'weight'];
        // filled = this.records.filter((r) => Object.values(this.drugDetails[r.drug.id]).find((v) => !fillCheckKeys.find((k) => !v.country_data.dimensions.array_value[k])));
        // const ids = filled.map((r) => r.drug_id);
        // this.filteredRecords = filtered.filter((r) => !ids.includes(r.drug_id));

        this.filteredRecords = filtered;
      }
      // console.log(ids, filled);
      this.filledRecords = filled;
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.post('/new/stores/actual/details', {
        action: 'list',
        store_id: 3,
        details: {country_data: ['dimensions', 'title']}
      });
      const countries = [4, 7];
      if (data.success) {
        this.drugDetails = data.records.reduce((acc, r) => {
          acc[r.drug_id] = {
            drug: {
              id: r.drug_id,
              title: r.drug.title,
              en_title: r.drug.en_title,
              pack_set: r.drug.pack_set,
              pack_box_comment: r.drug.pack_box_comment
            }, details: {}
          };
          r.drug.details.forEach((d) => {
            if (d.int_value && !countries.includes(d.int_value)) return;
            // if (!acc[r.drug_id][d.int_value]) acc[r.drug_id][d.int_value] = {};
            // if (!acc[r.drug_id][d.int_value][d.group_alias]) acc[r.drug_id][d.int_value][d.group_alias] = {};
            if (!acc[r.drug_id].details[d.group_alias]) acc[r.drug_id].details[d.group_alias] = {};
            if (!acc[r.drug_id].details[d.group_alias][d.alias]) acc[r.drug_id].details[d.group_alias][d.alias] = [];
            if (d.alias === 'dimensions' && !d.array_value?.width) d.array_value = {...this.groups.physics_data.array_value};
            acc[r.drug_id].details[d.group_alias][d.alias].push({...d, saved: !!d.int_value});
          })
          if (!acc[r.drug_id].details.country_data) acc[r.drug_id].details.country_data = {};
          if (!acc[r.drug_id].details.country_data.dimensions) acc[r.drug_id].details.country_data = {dimensions: []};
          if (!acc[r.drug_id].details.country_data.dimensions.length) {
            acc[r.drug_id].details.country_data.dimensions.push({
              drug_id: r.drug_id,
              type: 'array',
              int_value: !countries.includes(r.drug.income_country_id) ? 4 : r.drug.income_country_id,
              array_value: {}
            })
          }

          // Object.keys(acc[r.drug_id]).forEach((cId) => {
          //   if (!acc[r.drug_id][cId].country_data) acc[r.drug_id][cId].country_data = {};
          //   if (!acc[r.drug_id][cId].country_data.title) acc[r.drug_id][cId].country_data.title = {
          //     text_value: null,
          //     type: 'text',
          //     // int_value: this.countryId
          //     int_value: r.drug.income_country_id
          //   };
          //   if (!acc[r.drug_id][cId].country_data.dimensions) acc[r.drug_id][cId].country_data.dimensions = {
          //     type: 'array',
          //     int_value: !countries.includes(r.drug.income_country_id) ? 4 : r.drug.income_country_id,
          //     array_value: {}
          //   };
          // })
          // if (!Object.keys(acc[r.drug_id]).length) {
          //   acc[r.drug_id][r.drug.income_country_id] = {
          //     country_data: {
          //       title: {text_value: null, type: 'text', int_value: r.drug.income_country_id},
          //       dimensions: {type: 'array', int_value: this.countryId, array_value: {}}
          //     }
          //   }
          // }
          return acc;
        }, {});

        // let records = data.records.reduce((acc, r) => {
        //   acc.push({
        //     ...r,
        //     g_details: r.drug.details.reduce((ac, d) => {
        //       if (!ac[d.group_alias]) ac[d.group_alias] = {};
        //       ac[d.group_alias][d.alias] = d;
        //       return ac;
        //     }, {})
        //   })
        //   return acc;
        // }, []);
        // records = records.map((r, i) => {
        //   Object.keys({...this.groups}).forEach((g) => {
        //     if (!r.g_details[g]) r.g_details[g] = {};
        //     [...this.groups[g]].forEach((a) => {
        //       if (!r.g_details[g][a.alias]) r.g_details[g][a.alias] = {...a};
        //     })
        //   })
        //   return r;
        // });
        this.records = data.records;
        this.drugsImages = data.drugsImages;
        // this.filterDrugs();
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.m_input {
  min-width: 275px;
}

.max_w {
  width: 90px;
}
</style>
